import { IRestfulConfigMap } from "../../common/data-access/restful/restful-config-map";
import { envConfig } from "../../environments/env-config";

let clientServiceConfig: IRestfulConfigMap = {
    "clientService": {
        appPath: envConfig.appPath("cgp"),
        isAuth: true,
        actions: {
            // "getClientInfo": {
            //     method: "GET",
            //     path: "/api/builder/resource:builderType/url/latest:test?:id&platform=PC:language:region",
            //     paramDefaults: {
            //         builderType: "@builderType",
            //         test: "@test",
            //         id: "@id",
            //         language:"@language",
            //         region:"@region"
            //     }
            // },
            "getGlobalId": {
                method: "GET",
                path: "/api/common/key",
            },
            "creationClient": {
                method: "POST",
                path: "/api/partner/clients",
            },
            "findClientById": {
                method: "GET",
                path: "/api/partner/clients/externalClient/:wcClientId",
                paramDefaults: {
                    wcClientId: "@wcClientId"
                }
            },
            "mergeTempLibrary": {
                method: "POST",
                path: "/api/file/library/migrate/:srcRole/:srcUserId/to/:tgtRole/:tgtUserId",
                paramDefaults: {
                    srcRole: "@srcRole",
                    srcUserId: "@srcUserId",
                    tgtRole: "@tgtRole",
                    tgtUserId: "@tgtUserId"

                }
            }
        }
    }
}

type ActionKey = "getGlobalId" | "creationClient" | "findClientById" | "mergeTempLibrary";

export { clientServiceConfig };

export type { ActionKey };